export default __webpack_public_path__ + "static/media/IEFP1.86371a4d.png";